import React from 'react';
import { Divider, useTheme } from '@mui/material';

const DSDivider = (props: React.ComponentProps<typeof Divider>) => {
  const { palette } = useTheme();
  return (
    <Divider
      {...props}
      sx={{
        color: palette.divider,
        borderWidth: '2px',
        ...props.sx,
      }}
    />
  );
};

export default DSDivider;
